import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=47fc8f8a&scoped=true"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=47fc8f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc8f8a",
  null
  
)

export default component.exports